import {
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message } from "antd";
import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  FloatingLabel,
  Form,
  InputGroup,
  ListGroup,
  Modal,
  Row,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import Message from "../../../components/Message";
import {
  calculateAverageRating,
  generateServiceName,
} from "../../../controllers/addingnew";
import { MAID_CREATE_RESET } from "../../../redux/Constants/maidConstants";
import usePermissions from "../../../hook/userPermission";
import {
  clearMaidState,
  createMaid,
  deleteMaid,
  getAllMaids,
  updateMaid,
} from "../../../redux/slices/maidSlice";
import EmptyState from "../../../components/EmptyState";

const ValetList = ({ toAddMaid, toDeleteMaid }) => {
  const { hasPermission } = usePermissions();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [editValidated, setEditValidated] = useState(false);
  const [serviceNameError, setServiceNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [maidToDelete, setMaidToDelete] = useState(null);
  const [maidToEdit, setMaidToEdit] = useState(null);
  const [updatedFirstName, setUpdatedFirstName] = useState("");
  const [updatedLastName, setUpdatedLastName] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    serviceName: "",
    type: "valet",
    email: "",
    employId: "NaN",
  });
  const { userInfo } = useSelector((state) => state.userLogin);

  const {
    valets,
    fetchLoading,
    fetchError,
    createLoading,
    deleteSuccess,
    updateSuccess,
    createError,
    createSuccess,
  } = useSelector((state) => state.maids);

  const dispatch = useDispatch();

  const hotelId = userInfo.isAdmin == true ? userInfo._id : userInfo.hotel;
  const isB2c = !userInfo?.model.b2b;

  const handleClose = () => {
    dispatch(clearMaidState());
    setValidated(false);
    setShow(false);
    setServiceNameError(false);
    setEmailError(false);
    setFormData({
      firstName: "",
      lastName: "",
      serviceName: "",
      type: "valet",
      email: "",
      employId: "NaN",
    });
  };
  const handleDeleteModal = () => setDeleteModal(false);
  const handleEditClose = () => setEditModal(false);

  const handleFirstNameChange = (e) => {
    const newFirstName = e.target.value;
    const generatedServiceName = generateServiceName(
      newFirstName,
      formData.lastName,
      valets
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      firstName: newFirstName,
      serviceName: generatedServiceName,
    }));
  };
  const handleLastNameChange = (e) => {
    const newLastName = e.target.value;
    const firstLetterOfLastName = newLastName.charAt(0).toUpperCase();
    const generatedServiceName = generateServiceName(
      formData.firstName,
      newLastName,
      valets
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      lastName: newLastName,
      serviceName: generatedServiceName,
    }));
  };
  const handleEmailChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      email: e.target.value,
    }));
    setServiceNameError(false);
  };
  const handleEmployIdChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      employId: e.target.value,
    }));
    // setServiceNameError(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      const isDuplicateService = valets.some(
        (maid) =>
          maid.serviceName.toLowerCase().replace(/\s/g, "") ===
          formData.serviceName.toLowerCase().replace(/\s/g, "")
      );
      const isDuplicateEmail = valets.some(
        (maid) =>
          maid.email.toLowerCase().replace(/\s/g, "") ===
          formData.email.toLowerCase().replace(/\s/g, "")
      );
      if (isDuplicateService) {
        setServiceNameError(true);
        setValidated(false);
        return;
      } else if (isDuplicateEmail) {
        setEmailError(true);
        setServiceNameError(false);
        setValidated(false);
        return;
      } else {
        // Reset the service name error state
        setServiceNameError(false);
        setEmailError(false);

        try {
          await dispatch(
            createMaid({
              firstName: formData.firstName,
              lastName: formData.lastName,
              serviceName: formData.serviceName,
              type: formData.type,
              email: formData.email,
              employId: formData.employId,
              hotel: hotelId,
            })
          ).unwrap();

          message.success("Valet added successfully!");
          handleClose();
        } catch (err) {
          message.error(err || "Failed to add valet.");
        }
      }
    }
    setValidated(true);
  };
  const handleDelete = async () => {
    if (maidToDelete) {
      try {
        await dispatch(
          deleteMaid({ maidId: maidToDelete, maidType: "valet" })
        ).unwrap();

        message.success("Valet deleted!");
        setMaidToDelete(null);
        handleDeleteModal();
        dispatch(clearMaidState());
      } catch (error) {
        console.error("Error deleting maid:", error);
        message.error(error || "Failed to delete.");
      }
    }
  };
  const handleEdit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      try {
        await dispatch(
          updateMaid({
            id: maidToEdit._id,
            firstName: updatedFirstName,
            lastName: updatedLastName,
          })
        ).unwrap();

        message.success("Details updated!");
        handleEditClose();
        dispatch(clearMaidState());
      } catch (error) {
        console.error("Error updating maid:", error);
        message.error(error || "Failed to update details.");
      }
    }
    setEditValidated(true);
  };

  useEffect(() => {
    dispatch(getAllMaids({ hotelId }));
    if (maidToEdit != null) {
      setUpdatedFirstName(maidToEdit.firstName);
      setUpdatedLastName(maidToEdit.lastName);
    }
  }, [dispatch, hotelId, maidToEdit, updateSuccess, deleteSuccess]);

  const styles = {
    shadow: {
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    },
  };

  const filteredValets = valets.filter((valet) =>
    valet.serviceName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <>
      <Alert
        className="mt-3"
        show={!!confirmationMessage}
        variant={
          confirmationMessage.includes("successfully") ? "success" : "danger"
        }
        onClose={() => setConfirmationMessage("")}
        // dismissible
      >
        {confirmationMessage}
      </Alert>
      {/* --------------------------------------------- EDIT MODAL --------------------------------------------- */}
      <Modal
        show={editModal}
        onHide={handleEditClose}
        backdrop="static"
        centered
      >
        <Modal.Header className="bg-primary">
          <Modal.Title className="mx-auto text-light">Edit Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={editValidated} onSubmit={handleEdit}>
            <Row>
              <Col sm={6}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    required
                    pattern="[A-Za-z]+"
                    type="text"
                    value={updatedFirstName}
                    onChange={(e) => {
                      setUpdatedFirstName(e.target.value);
                    }}
                    placeholder="Enter First Name"
                  />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    required
                    pattern="[A-Za-z]+"
                    type="text"
                    value={updatedLastName}
                    onChange={(e) => {
                      setUpdatedLastName(e.target.value);
                    }}
                    placeholder="Enter Last Name"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm="auto" className="ms-auto">
                <Button
                  variant="secondary"
                  className="mx-3"
                  onClick={handleEditClose}
                >
                  Close
                </Button>
                <Button variant="success" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ------------------------------------------ DELETE MODAL ----------------------------------------- */}
      <Modal
        show={deleteModal}
        onHide={handleDeleteModal}
        backdrop="static"
        centered
      >
        <Modal.Body className="p-4">
          <b>Are you sure you want to remove this valet from team?</b>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* --------------------------------------------- ADD NEW MODAL ------------------------------------------- */}
      <Modal show={show} onHide={handleClose} backdrop="static" centered>
        <Modal.Header className="bg-primary">
          <Modal.Title className="mx-auto text-light">
            Add a new Valet
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {createLoading ? (
            <Loader />
          ) : (
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <FloatingLabel
                className="my-3"
                controlId="floatingName"
                label="First name"
                value={formData.firstName}
                onChange={handleFirstNameChange}
              >
                <Form.Control
                  required
                  type="text"
                  placeholder="Name"
                  pattern="[A-Za-z]+"
                />
              </FloatingLabel>
              <FloatingLabel
                className="my-3"
                controlId="floatingName"
                label="Last name"
                value={formData.lastName}
                onChange={handleLastNameChange}
              >
                <Form.Control
                  required
                  type="text"
                  placeholder="Name"
                  pattern="[A-Za-z]+"
                />
              </FloatingLabel>
              <FloatingLabel
                className="my-3 text-muted"
                controlId="floatingId"
                label="Employee ID (optional)"
                value={formData.employId}
                onChange={handleEmployIdChange}
              >
                <Form.Control type="text" placeholder="#123" />
              </FloatingLabel>

              <Form.Group className="my-3" controlId="">
                <Form.Control
                  required
                  type="text"
                  placeholder="Service name"
                  value={formData.serviceName}
                  isInvalid={serviceNameError}
                  readOnly={!serviceNameError}
                  onChange={(e) => {
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      serviceName: e.target.value,
                    }));
                  }}
                />
                {
                  <Form.Text
                    className={serviceNameError ? "text-danger" : "text-muted"}
                  >
                    {serviceNameError
                      ? "This name is not available, please edit."
                      : "(Unique name assigned for tipping)"}
                  </Form.Text>
                }
              </Form.Group>
              <FloatingLabel
                className="my-3"
                controlId="floatingInput"
                label="Email address"
                onChange={handleEmailChange}
              >
                <Form.Control
                  required
                  type="email"
                  placeholder="name@example.com"
                />
                {emailError ? (
                  <Form.Text className="text-danger">
                    This email is alreday in use
                  </Form.Text>
                ) : (
                  <></>
                )}
                <Form.Control.Feedback type="invalid">
                  Please enter a valid email*
                </Form.Control.Feedback>
              </FloatingLabel>
              <Row className="my-3">
                <Col sm="auto" className="ms-auto">
                  <Button
                    variant="secondary"
                    className="me-3"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button className="px-4" variant="primary" type="submit">
                    Add
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
      </Modal>
      <Row className="m-0">
        {/* ----------------------------------------- ADD NEW BUTTON -------------------------------------------------- */}
        <Col>
          {hasPermission("toAddMaid") ? (
            <>
              <Row className="align-items-center mt-4">
                <Col sm={3} className="ms-auto p-0">
                  {" "}
                  <InputGroup className="ms-auto border border-1 rounded-4 p-1">
                    <Button
                      className="bg-transparent border-0 p-1"
                      id="button-addon1"
                    >
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="text-primary mx-2"
                      />
                    </Button>
                    <Form.Control
                      className="border-0 p-0"
                      aria-label="search"
                      aria-describedby="basic-addon1"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="auto" className="">
                  <Button
                    className="rounded-4"
                    variant="outline-success"
                    onClick={() => {
                      setShow(true);
                      setValidated(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Add new
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
          {/* ------------------------------------------------------ VALET LIST ------------------------------------ */}
          <Row className="py-4">
            <Col className="p-4 rounded-4" style={styles.shadow}>
              <Row>
                <Col md={2} className="text-primary fw-semibold fs-5">
                  Employ ID
                </Col>
                <Col md={2} className="text-primary fw-semibold fs-5">
                  Name
                </Col>
                <Col md={3} className="text-primary fw-semibold fs-5 p-0">
                  Email
                </Col>
                <Col
                  md={2}
                  className="text-primary fw-semibold fs-5 text-center"
                >
                  @
                </Col>
                <Col md={1} className="text-primary fw-semibold fs-5">
                  Ratings
                </Col>
              </Row>
              <hr className="my-3" />
              <Row>
                <Col>
                  {fetchLoading ? (
                    <Loader />
                  ) : fetchError ? (
                    <Message>{fetchError}</Message>
                  ) : (
                    <>
                      {filteredValets.length === 0 ? (
                        <EmptyState
                          title="No valets found"
                          description="No valets have been added yet."
                          onButtonClick={() => setShow(true)}
                        />
                      ) : (
                        filteredValets.map((maid, index) => (
                          <>
                            <Row key={index} className="align-items-center">
                              <Col md={2}>
                                <span className="text-muted">
                                  {maid.employId}
                                </span>
                              </Col>
                              <Col md={2}>
                                <Row className="align-items-center">
                                  {isB2c && (
                                    <Col sm={1} className="pe-0 m-0">
                                      <div
                                        className={
                                          maid.chargesStatus
                                            ? "rounded-circle bg-success display-flex"
                                            : "rounded-circle bg-danger"
                                        }
                                        style={{ width: "8px", height: "8px" }}
                                      ></div>
                                    </Col>
                                  )}
                                  <Col className="ps-2 text-break">
                                    {maid.firstName + " " + maid.lastName}
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={3} className="p-0">
                                <span className="fst-italic text-break text-muted">
                                  {maid.email}
                                </span>
                              </Col>
                              <Col
                                md={2}
                                className="text-success ps-3 text-center"
                              >
                                {maid.serviceName}
                              </Col>
                              <Col xs={1} className="text-success text-center">
                                {calculateAverageRating(maid.ratings).toFixed(
                                  1
                                )}
                              </Col>
                              <Col xs={2} className="ms-auto" sm="auto">
                                {hasPermission("toAddMaid") && (
                                  <Button
                                    className="mx-2"
                                    variant="outline-dark"
                                    onClick={() => {
                                      setMaidToEdit(maid);
                                      setEditModal(true);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faPenToSquare} />
                                  </Button>
                                )}
                                {hasPermission("toDeleteMaid") && (
                                  <Button
                                    className="mx-2"
                                    variant="outline-danger"
                                    onClick={() => {
                                      setDeleteModal(true);
                                      setMaidToDelete(maid._id);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </Button>
                                )}
                              </Col>
                            </Row>
                            <hr className="my-2" />
                          </>
                        ))
                      )}
                    </>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ValetList;
